var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "mb14 normal-page",
        },
        [
          _c("div", { staticClass: "flex-between mb14" }, [
            _c("div", { staticClass: "title" }, [_vm._v("检测模板")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.openCreate },
                  },
                  [_vm._v("新建模板")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.getList } },
                  [_vm._v("刷新")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.list, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "70" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "code",
                  label: "编码",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "名称",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "business_type_id",
                  label: "业务类型ID",
                  width: "110",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "启",
                            "inactive-text": "停",
                            width: 50,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onStatus(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updated_at",
                  label: "更新时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "320", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openTree(scope.row)
                              },
                            },
                          },
                          [_vm._v("树预览")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openImport(scope.row)
                              },
                            },
                          },
                          [_vm._v("导入JSON")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openHistory(scope.row)
                              },
                            },
                          },
                          [_vm._v("历史")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openClone(scope.row)
                              },
                            },
                          },
                          [_vm._v("克隆")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新建模板",
            visible: _vm.createVisible,
            width: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "110px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "业务类型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.createForm.business_type_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "business_type_id", $$v)
                        },
                        expression: "createForm.business_type_id",
                      },
                    },
                    _vm._l(_vm.bizList, function (b) {
                      return _c("el-option", {
                        key: b.id,
                        attrs: { label: b.name, value: b.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模板编码" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "如 TPL_268V" },
                    model: {
                      value: _vm.createForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "code", $$v)
                      },
                      expression: "createForm.code",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模板名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.createForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "name", $$v)
                      },
                      expression: "createForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.createForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "remark", $$v)
                      },
                      expression: "createForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.createVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitCreate },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入 config_json（整包覆盖）",
            visible: _vm.importVisible,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.importVisible = $event
            },
          },
        },
        [
          _c("p", { staticClass: "tip" }, [
            _vm._v(
              "当前模板：" +
                _vm._s(_vm.current && _vm.current.name) +
                "（#" +
                _vm._s(_vm.current && _vm.current.id) +
                "）"
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-upload",
            {
              ref: "uploader",
              attrs: {
                drag: "",
                action: "",
                "auto-upload": false,
                limit: 1,
                accept: ".json,application/json",
                "on-change": _vm.onFileChange,
                "on-remove": function () {
                  return (_vm.importFile = null)
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _vm._v(" "),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("将 JSON 拖到此处，或"),
                _c("em", [_vm._v("点击选择")]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.importVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitImport },
                },
                [_vm._v("覆盖导入")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.treeTitle,
            visible: _vm.treeVisible,
            size: "55%",
            direction: "rtl",
          },
          on: {
            "update:visible": function ($event) {
              _vm.treeVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.treeLoading,
                  expression: "treeLoading",
                },
              ],
              staticClass: "tree-wrap",
            },
            [
              _vm.treeMeta
                ? _c("div", { staticClass: "tree-meta mb14" }, [
                    _vm._v(
                      "\n        schema=" +
                        _vm._s(_vm.treeMeta.schema_version) +
                        " · 部位 " +
                        _vm._s(_vm.treeMeta.parts_count) +
                        " · 缺陷 " +
                        _vm._s(_vm.treeMeta.defects_count) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.treeData.length
                ? _c(
                    "el-collapse",
                    _vm._l(_vm.treeData, function (mod, mi) {
                      return _c(
                        "el-collapse-item",
                        {
                          key: "m" + mi,
                          attrs: { title: mod.name, name: "m" + mi },
                        },
                        _vm._l(mod.groups, function (grp, gi) {
                          return _c(
                            "div",
                            { key: "g" + mi + "-" + gi, staticClass: "grp" },
                            [
                              _c("div", { staticClass: "grp-title" }, [
                                _vm._v(_vm._s(grp.name)),
                              ]),
                              _vm._v(" "),
                              _vm._l(grp.children, function (part, pi) {
                                return _c(
                                  "div",
                                  {
                                    key: part.code + "-" + pi,
                                    staticClass: "part",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "part-name" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(part.name) +
                                            "\n                "
                                        ),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                            },
                                          },
                                          [_vm._v(_vm._s(part.code))]
                                        ),
                                        _vm._v(" "),
                                        part.participates_judge
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "danger",
                                                },
                                              },
                                              [_vm._v("参与定性")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        part.is_nev
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "success",
                                                },
                                              },
                                              [_vm._v("新能源")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    part.defects && part.defects.length
                                      ? _c(
                                          "div",
                                          { staticClass: "part-sub" },
                                          [
                                            _vm._v(
                                              "\n                缺陷 " +
                                                _vm._s(part.defects.length) +
                                                "：\n                "
                                            ),
                                            _vm._l(
                                              part.defects.slice(0, 8),
                                              function (d, di) {
                                                return _c(
                                                  "span",
                                                  { key: d.defect_code || di },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(d.defect_name) +
                                                        _vm._s(
                                                          di <
                                                            Math.min(
                                                              7,
                                                              part.defects
                                                                .length - 1
                                                            )
                                                            ? "、"
                                                            : ""
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            part.defects.length > 8
                                              ? _c("span", [_vm._v("…")])
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      )
                    }),
                    1
                  )
                : _c("el-empty", { attrs: { description: "暂无树数据" } }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "覆盖历史（最近20次）",
            visible: _vm.historyVisible,
            width: "640px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.historyVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.historyLoading,
                  expression: "historyLoading",
                },
              ],
              attrs: { data: _vm.historyList, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "70" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "remark", label: "备注", "min-width": "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created_by", label: "操作人", width: "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "created_at",
                  label: "时间",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.restoreHistory(scope.row)
                              },
                            },
                          },
                          [_vm._v("还原")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "克隆模板",
            visible: _vm.cloneVisible,
            width: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.cloneVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "110px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新编码" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.cloneForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.cloneForm, "code", $$v)
                      },
                      expression: "cloneForm.code",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "新名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.cloneForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.cloneForm, "name", $$v)
                      },
                      expression: "cloneForm.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.cloneVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.saving,
                  },
                  on: { click: _vm.submitClone },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }